import {hasClass} from "./utils";

function getElementVisibleRect(el) {
  const m = {x: -Infinity, y: -Infinity, w: Infinity, h: Infinity};
  const H = window.innerHeight || document.documentElement.clientHeight;
  const W = document.documentElement.clientWidth;

  while (el && el !== document.body && !hasClass(el, "modal-dialog")) {
    if (el.getBoundingClientRect) {
      const br = el.getBoundingClientRect();
      if (br.x > m.x) m.x = br.x;
      if (br.y > m.y) m.y = br.y;
      let b = br.bottom;
      let r = br.right;
      if (br.bottom > H) b = H;
      if (br.right > W) r = W;
      if (r < m.w) m.w = r;
      if (b < m.h) m.h = b;
    }
    el = el.parentNode;
  }

  if (m.x > 0) {
    m.w = m.w - m.x;
    m.x = 0;
  }

  if (m.y > 0) {
    m.h = m.h - m.y;
    m.y = 0;
  }

  return m;
}

export class VisibleCenterer {
  constructor(opts) {
    this.centered = opts.centered;
    this.wrapper = opts.wrapper;
  }

  update() {
    const self = this;
    $(this.wrapper).find(this.centered).filter(":visible").each(function() {
      const $this = $(this);
      const $wrapper = $this.closest(self.wrapper);
      const rect = getElementVisibleRect($wrapper.get(0));
      const offset = $wrapper.offset();
      $this.css({
        position: "absolute",
        left: (rect.w / 2 - rect.x - (offset.left < 0 ? offset.left : 0)) + 'px',
        top: (rect.h / 2 - rect.y - (offset.top < 0 ? offset.top : 0)) + 'px'
      });
    });
  }
}